module.exports = __webpack_public_path__ + "static/img/drone_04.7c171ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/drone_04.jpg
// module id = YPHV
// module chunks = 0